import { render, staticRenderFns } from "./takeOutOrder.vue?vue&type=template&id=05d45d16&scoped=true"
import script from "./takeOutOrder.vue?vue&type=script&lang=js"
export * from "./takeOutOrder.vue?vue&type=script&lang=js"
import style0 from "./takeOutOrder.vue?vue&type=style&index=0&id=05d45d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d45d16",
  null
  
)

export default component.exports